<template>
  <div>
    <div class="page-header page-header-small">
      <parallax class="page-header-image"
                style="background-image: url('/resource_social22/img/bg_social.png')"></parallax>
      <div class="content" style="margin-top: 8%;">
        <div class="container my-0">
          <div class="col-md-12 ml-auto mr-auto">
            <card type="login" plain>
              <!--            <div slot="header" class="logo-container">-->
              <!--              <img v-lazy="'img/now-logo.png'" alt=""/>-->
              <!--            </div>-->
              <h2>Shanghai-HK Interdisciplinary Shared Tasks (2022) </h2>
              <div class="text-left text_bold">
                <p class="mb-2">
                  The shared tasks on social media analysis is jointly organized by the Hong Kong Polytechnic
                  University, the Chinese University of Hong Kong, Fudan University, and Tongji University. Datasets are
                  collected and annotated by SMART Group (PolyU) and DISC Lab (Fudan) to explore the NLP application in
                  interdisciplinary domains such as rumor verification, poll generation, emotion analysis, user profile
                  modeling
                  and code-switched text analysis. Besides, the WRD Big Data Institute will provide large-scale weibo
                  corpus to help the training of general pretrained language models.
                </p>
                <p class="mb-2">
                  The aim of this competition is to promote the application of interdisciplinary social media analysis
                  and provide communication platform for researchers and practitioners of relative fields. Welcome to
                  register for the shared tasks if you are interested in social media processing!
                </p>
              </div>
              <div class="card-footer text-center">
                <router-link to="/regist">
                  <n-button type="primary" round class="category px-5">Regist Now</n-button>
                </router-link>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-7">
          <!-- Schedule -->
          <div class="pt-5 pb-4">
            <h3>Schedule</h3>
            <div>
              <p class="mb-3">
                <span class="date">
                  <span class="month font-weight-normal">Mar</span>
                  <span class="day text-primary"> 7</span>
                </span>
                Open for
                <router-link to="/regist">registration</router-link>
              </p>
              <p>
                 <span class="date">
                  <span class="month font-weight-normal">Mar</span>
                  <span class="day text-primary"> 10</span>
                 </span>
                <span class="dateto">-</span>
                <span class="date">
                  <span class="month font-weight-normal">May</span>
                  <span class="day text-primary"> 25</span>
                 </span>
                Upload test result (phase 1)
              </p>
              <p>
                 <span class="date">
                  <span class="month font-weight-normal">May</span>
                  <span class="day text-primary"> 26</span>
                 </span>
                <span class="dateto">-</span>
                <span class="date">
                  <span class="month font-weight-normal">May</span>
                  <span class="day text-primary"> 31</span>
                 </span>
                Upload test result (phase 2)
              </p>
              <p>
                 <span class="date">
                  <span class="month font-weight-normal">Jun</span>
                  <span class="day text-primary"> 1</span>
                 </span>
                <span class="dateto">-</span>
                <span class="date">
                  <span class="month font-weight-normal">Jun</span>
                  <span class="day text-primary"> 4</span>
                 </span>
                Submit report for winning teams
              </p>
              <p>
                 <span class="date">
                  <span class="month font-weight-normal">Jun</span>
                  <span class="day text-primary"> 6</span>
                 </span>
                <span class="dateto">-</span>
                <span class="date">
                  <span class="month font-weight-normal">Jun</span>
                  <span class="day text-primary"> 8</span>
                 </span>
                Online symposium
                (<a href="/resource_social22/data/program.pdf" target="_blank">Program File</a>)
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="pt-5 pb-4">
            <h3>Awards</h3>
            <div>
              <p>
                The <span class="font-weight-normal">top three</span> teams for each task (<span
                  class="font-weight-normal">15</span> in total) will be awarded prizes.
              </p>
              <p>
                The champion: <span class="font-weight-normal">HK$ 5,000</span>
              </p>
              <p>
                The first runner-up: <span class="font-weight-normal">HK$ 3,000</span>
              </p>
              <p>
                The second runner-up: <span class="font-weight-normal"> HK$ 2,000</span>
              </p>
              <p>
                * Awards will be delivered in the form of consumption coupons. Winning teams will also have electronic
                certificates and be invited to attend the workshop.
              </p>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <h3>Guidelines</h3>
            <h5><i class="now-ui-icons arrows-1_minimal-right mr-2" aria-hidden="true"></i>Registration</h5>
            <p>Submit your email, organization, team name and intending tasks (can choose 1-5 tasks to participate) in
              the
              <router-link to="/regist">registration</router-link>
              page.
              Please ensure input the right email address (not editable) for further contact.
              Registration is open until the end of the phase 1 testing period.
            </p>

            <h5><i class="now-ui-icons arrows-1_minimal-right mr-2" aria-hidden="true"></i>Testing Period</h5>
            <p>
              The competition adopts <strong>two-phase</strong> testing.
            </p>
            <p>
              During <strong>phase 1</strong>, you should submit your <strong>prediction results</strong> through the
              <router-link to="/console">console</router-link>
              page.
              The website will automatically compute and record the evaluation metrics.
              The format of prediction results should follow the requirements in the
              <router-link to="/task">task</router-link>
              page.
              The maximum number of uploads per day is <strong>10</strong>.
            </p>
            <p>
              During <strong>phase 2</strong>, teams that surpass the baselines should submit <strong>trained models &
              running instructions</strong> through the
              <router-link to="/console">console</router-link>
              page.
              The organizers will run the model and obtain the evaluation metrics as the basis for final ranking.
              Each team has <strong>3</strong> opportunities to run models successfully.
            </p>

            <h5><i class="now-ui-icons arrows-1_minimal-right mr-2" aria-hidden="true"></i>Contact</h5>
            <p>If you have any questions, please contact our organization comittee (disclab@fudan.edu.cn).</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Card, Button, FormGroupInput, Checkbox} from '@/components';

export default {
  name: "indexHome",
  components: {
    Card,
    [Button.name]: Button,
  },
}
</script>

<style scoped>

.date {
  float: left;
  height: 30px;
  width: 68px;
  /*background: url(date.png) no-repeat;*/
  margin-right: 10px;
  padding-top: 0px;
  line-height: normal;
  border: 2px solid #000000;
  display: block;
  text-align: center;
}

.dateto {
  float: left;
  height: 30px;
  width: 5px;
  /*background: url(date.png) no-repeat;*/
  margin-right: 10px;
  padding-top: 0px;
  line-height: normal;
  display: block;
  text-align: center;
}

.date .day {
  /*display: block;*/
  text-align: center;
  padding-top: 5px;
  color: #222;
  font-size: 18px;
  font-weight: bold;
}

.meta {
  /*display: block;*/
  font-size: 11px;
  color: #666;
}

</style>